import BaseApiClient from './baseApiClient';

/**
 * エラーログ専用APIクライアント
 */
class ErrorLogApiClient extends BaseApiClient {
  constructor() {
    super();
    // エンドポイントを追加（既存の設定を拡張）
    this.endpoints = {
      ...this.endpoints,
      ERROR_LOG: '/api/log/error'
    };
  }
}

// シングルトンインスタンスを作成
const errorLogApiClient = new ErrorLogApiClient();

/**
 * エラーログサービス
 * フロントエンドエラーをバックエンドに送信
 */
export const errorLogService = {
  /**
   * エラーログをバックエンドに送信
   * @param {Object} errorData - エラー情報
   * @param {string} errorData.message - エラーメッセージ
   * @param {string} errorData.stack - スタックトレース
   * @param {string} errorData.context - エラー発生箇所
   * @param {string} errorData.url - エラー発生時のURL
   * @param {string} errorData.userAgent - ユーザーエージェント
   * @param {string} errorData.timestamp - タイムスタンプ
   * @returns {Promise<Object>} レスポンス
   */
  async logError(errorData) {
    try {
      const response = await errorLogApiClient.post(
        errorLogApiClient.endpoints.ERROR_LOG,
        {
          message: errorData.message || 'Unknown error',
          stack: errorData.stack || null,
          context: errorData.context || null,
          url: errorData.url || window.location.href,
          userAgent: errorData.userAgent || navigator.userAgent,
          timestamp: errorData.timestamp || new Date().toISOString()
        }
      );

      return {
        success: response.ok,
        data: response.data
      };
    } catch (error) {
      // エラーログ送信自体が失敗した場合はコンソールに出力のみ
      // 無限ループを防ぐため、再送信はしない
      console.warn('[ERROR LOG SERVICE] Failed to send error log:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};